import { ThemeColorModeProps } from '../utils/cpds-utils';

export interface TabContainerProps extends ThemeColorModeProps {
  tabType: 'EQUAL_WIDTH' | 'NATURAL_WIDTH';
  scrollWidth: number;
  isScrollable: 'DEFAULT' | 'SCROLLABLE' | 'NOT_SCROLLABLE';
}

export interface CpdsTabProps extends React.HTMLAttributes<HTMLDivElement>, ThemeColorModeProps {
  domRef?: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
  exClasses?: string;
  styleOverrides?: React.CSSProperties;
  onTabSelect: (selectedIndex: number, e?: MouseEvent | KeyboardEvent) => void;
  selectedTab: number;
  forceScrollTabListInMobile?: boolean;
  tabType?: 'EQUAL_WIDTH' | 'NATURAL_WIDTH';
  tabItemColor?: string;
  tabItemHoverColor?: string;
  tabItemHighlightColor?: string;
  titleData?: TitleData;
  ref?: any;
}

export interface CpdsTabNavItemProps extends React.HTMLAttributes<HTMLAnchorElement> {
  name: string;
  selected?: boolean;
  index?: number;
  exClasses?: string;
  onClickItem?: (selectedIndex: number, e?: MouseEvent | KeyboardEvent) => void;
}

export interface CpdsTabPanetProps extends React.HTMLAttributes<HTMLDivElement> {
  selected?: boolean;
}

export interface TitleData {
  title?: string;
  description?: string;
  eyebrow?: string;
}

export const TabTypes = {
  EQUAL_WIDTH: 'EQUAL_WIDTH',
  NATURAL_WIDTH: 'NATURAL_WIDTH',
};
